<template>
	<div class="content__column content__column--small" v-if="brand">
		<h1 class="content__title">Editar / Crear Marca</h1>
		<form class="form" @submit.prevent="saveBrand">
			<div class="form__fieldset">
				<div class="form__container">
					<label for="title" class="form__label form__label--required">Nombre del diseñador</label>
					<input type="text" class="form__input" name="name" id="name" v-model="brand.name" v-validate="validation.name" />
					<span v-show="errors.has('name')" class="form__alert" v-text="errors.first('name')"></span>
					<span v-show="errors.has('webname')" class="form__alert" v-text="errors.first('webname')"></span>
				</div>
				<div class="form__container">
					<label class="form__label form__label--required" for="status_id"> Estatus de la Marca</label>
					<div class="form__select-container">
						<select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="brand.status_id">
							<option hidden :value="null">Seleccione un estatus</option>
							<option v-for="(status, index) in brandStatus" :key="index" :value="status.id" v-text="status.name"></option>
						</select>
					</div>
					<span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
				</div>
			</div>
			<input type="submit" class="btn btn__action btn--regular" value="Guardar" />
			<button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">
				Agregar Nueva Marca
			</button>
		</form>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import { brandStatus } from './mocks'
	import Mixins from './mixins'

	export default {
		props: {
			brand: {
				type: Object,
				required: false,
				default: function() {
					return {
						id: null,
						name: null,
						status_id: null
					}
				}
			}
		},
		mixins: [httpService, Mixins],
		data: function() {
			return {
				brandStatus: brandStatus,
				validation: {
					name: 'required|max:100',
					webname: 'max:100',
					status_id: 'required|min_value:1|max:4',
				}
			}
		},
		methods: {
			saveBrand: function() {
				this.$validator.validateAll().then(result => {
					if (result) {
						let httpRequest = {
							params: '',
							module: 'brands',
							element: this.brand
						}
						let action
						if (this.brand.id) {
							action = this.put(this.brand.id, httpRequest)
						} else {
							action = this.post(httpRequest)
						}
						action
							.then(response => {
								if (!this.brand.id) {
									this.brand.id = response.data.current_id
								}
								this.$store.commit('elementChanged', {
									module: 'brandEdit',
                	time: Math.round(new Date().getTime() / 1000)
								})
								this.$store.commit('notificate', {
									title: 'MARCA GUARDADA',
									text: 'La marca ha sido guardada correctamente',
									type: 'success'
								})
							})
							.catch(() => {
								this.$store.commit('notificate', {
									title: 'MARCA NO GUARDADA',
									text: 'La marca no ha sido guardada, por favor, intente más tarde',
									type: 'error'
								})
							})
					}
				})
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/designers/edit.vue